module.exports = __webpack_public_path__ + "static/media/img-03.616202a9.png";